define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var SearchInputViewController = require('web-agent-viewControllers/SearchInputViewController');

    var TableSearchViewController = ViewController.extend({
        ControllerName: "TableSearchViewController",

        LPViewMap: {
            searchInput: ".lpview_search_input_placeholder"
        },

        LPClassesMap: {
            SearchCaption: "search_caption",
            SearchCaptionTooltip: "search_caption_tooltip",
            filterShow: 'filter_show',
            filterOn: 'filter_on'
        },

        LPIconStatus: {
            on: "on",
            off: "off",
            show: "show",
            hide: "hide"
        },

        LPActions: {
            clear: "clear",
            filter: "filter"
        },

        initialize: function (constructorData) {
            this.textsPrefix = constructorData.textsPrefix ? constructorData.textsPrefix + "_" : "";
            this.updateQueryCallback = constructorData.updateQueryCallback;
            this.tableName = constructorData.tableName;
            this.searchCaption = constructorData.textsPrefix ? "{{" + this.textsPrefix + this.LPClassesMap.SearchCaption + "}}" : "";
            this.searchCaptionTooltip = constructorData.textsPrefix ? "{{" + this.textsPrefix + this.LPClassesMap.SearchCaptionTooltip + "}}" : "";
            this.context = constructorData.context || this;
            this.tableLastSentQueryModelPath = constructorData.tableLastSentQueryModelPath;
            this.tableItemsStateModelPath = constructorData.tableItemsStateModelPath;
            this.notifyFilterOpenedCallback = constructorData.notifyFilterOpenedCallback;
            this.notifyFilterClosedCallback = constructorData.notifyFilterClosedCallback;
            this.actionType = constructorData.actionType;
            this.iconCallback = this.setFilterIcon;
            this.disabledOption = constructorData.disabledOption;
            this.iconId = constructorData.iconId;
            this.filterIdPrefix = "PageSearchFilterId";
            this.afterTitle = constructorData.afterTitle;
            this.alphaOption = constructorData.alphaOption;
            this.initializeView();
            this.searchFilterEventCallback = constructorData.searchFilterEventCallback;
            this.filterDefaultSelection = constructorData.filterDefaultSelection;

            //set up filter with its data
            if (this.actionType === this.LPActions.filter) { //default action is "clear"
                this.filterOptions = {
                    filterItems: constructorData.filterItems,
                    filterDefaultSelection: constructorData.filterDefaultSelection
                };
            }
            this.currentFilter = this.modelController.getSessionData({name: this.tableName, key: "searchTag"}) || "";
            this.searchInput = new SearchInputViewController({
                searchFilterEventCallback: this.searchFilterEventCallback,
                inputBlurredWidth: "95px",
                inputFocusedWidth: "190px",
                keyUpCallback: this.onKeyUp,
                blurCallback: this.search,
                clearSearchCallback: this.search,
                searchIconCallback: this.search,
                focusCallback: this.onFocus,
                filterIconCallback: this.iconCallback,
                context: this,
                filterOptions: this.filterOptions,
                iconId: this.iconId,
                filterIdPrefix: this.filterIdPrefix,
                disabledOption: this.disabledOption,
                afterTitle: this.afterTitle,
                tableName: this.tableName,
                alphaOption: this.alphaOption,
                filterDefaultSelection: this.filterDefaultSelection
            });
            this.addViewController({viewController : this.searchInput, target: this.LPViewMap.searchInput});
        },

        events: function () {
            this.viewEventsHandler.bindEvent({appName: this.tableName, UIEvent: this.viewEventsHandler.eventType.TABLE_SEARCH_FILTER_CHANGED, callback: this.search});
            this.bindModel({modelPath : this.tableItemsStateModelPath, callback : this.handleTableStateChanged});
        },

        render: function () {
        }
    });

    TableSearchViewController.prototype.initializeView = function () {
        var tableTemplate = require("web-agent-templates/LP_table_search.html");
        // var tableTemplate = lpUtils.loadResource("web-agent-templates/LP_table_search.html");
        var textInjection = {
            searchCaption: this.searchCaption,
            searchCaptionTooltip: this.searchCaptionTooltip
        };
        tableTemplate = this.injectTextDefaults(tableTemplate, textInjection);
        this.view = this.createView({template: tableTemplate});
    };

    TableSearchViewController.prototype.onKeyUp = function (e) {
        var keyCode = lpUtils.getKeyCode(e);
        if (keyCode === 13) {
            this.search();
        }
    };

    TableSearchViewController.prototype.onFocus = function () {
        this.notifyFilterOpenedCallback.call(this, this.filterName);
    };

    TableSearchViewController.prototype.search = function () {
        this.notifyFilterClosedCallback.call(this);
        this.modelController.saveSessionData({name: this.tableName, key: "searchArea", value: this.searchInput.getSelectedItems()});
        if( this.currentFilter !== this.searchInput.getText() || this.searchInput.getText() !== ""){
            this.currentFilter = this.searchInput.getText();
            this.modelController.saveSessionData({name: this.tableName, key: "searchTag", value: this.currentFilter});

            //special filter case (in history->search bar) requires different query items
            var query = {
                startPage: true,
                searchTag: this.currentFilter
            };
            if (this.searchInput.isChatIdQuery()) {
                query.searchArea = "chatId";
            } else { //else, send regular query
                query.searchArea = this.searchInput.getSelectedItems();
            }
            this.updateQueryCallback.call(this.context, query);
        }
    };

    /**
     * Manage the filter icon according to the filter status
     * @param context
     * @param iconId - numerical identifier for the icon that is added to the class name that represents this icon
     * @param status - show, hide, on, off
     */
    TableSearchViewController.prototype.setFilterIcon = function (iconId, status) {
        switch (status) {
            case this.LPIconStatus.on:
                this.addClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterOn); break;
            case this.LPIconStatus.off:
                this.removeClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterOn); break;
            case this.LPIconStatus.show:
                this.addClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterShow); break;
            case this.LPIconStatus.hide:
                this.removeClass(this.getFirstElement("." + this.filterIdPrefix + iconId), this.LPClassesMap.filterShow); break;
        }
    };

    TableSearchViewController.prototype.handleTableStateChanged = function (data) {
        if (data && data.newValue) {
            switch (data.newValue.status) {
                case "fetching":
                    this.searchInput.disableActions();
                    break;
                case "fetched":
                    var lastQuery = this.getModelParam(this.tableLastSentQueryModelPath);
                    if (!this.searchInput.isFocused()) {
                        this.searchInput.setText(lastQuery.searchTag || "");
                    }
                    this.searchInput.enableActions();
                    break;
                default:
                    this.searchInput.enableActions();
            }
        }
    };

    return TableSearchViewController;

});
